import React, { PropsWithChildren, useEffect, useRef } from 'react';
import { styled } from 'styled-components';

import { DeviceQueries } from 'Common/components/styled';

const Dropdown = ({ onClose, children }: PropsWithChildren<{ onClose: () => void }>) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && event.target && !ref.current.contains(event.target as Node)) {
        onClose();
      }
    };
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, onClose]);

  return <DropdownMenu ref={ref}>
    {children}
  </DropdownMenu>;
};

const DropdownMenu = styled.div`
  position: absolute;
  top: 56px;
  right: 0;
  background: white;
  box-shadow: 0 8px 24px rgba(2, 3, 59, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  border: 1px solid #E4E7EF;
  overflow: hidden;
  min-width: 200px;
  z-index: 1000;
  margin: 8px 16px;

  @media (${DeviceQueries.mobile}) {
    right: 0;
    left: 0;
    margin: 8px 16px;
  }
`;

export const DropdownItem = styled.div<{ $current?: boolean, $disabled?: boolean }>`
  padding: 11px 16px;
  color: ${({ $current, $disabled }) => {
    if ($current) {
      if ($disabled) {
        return '#8890A5';
      } else {
        return '#008AFF';
      }
    } else {
      if ($disabled) {
        return '#8890A5';
      } else {
        return '#1A1D2B';
      }
    }
  }};
  font-weight: ${({ $current }) => $current ? '600' : '400'};
  font-size: 14px;
  cursor: ${({$disabled}) => $disabled ? 'not-allowed' : 'pointer'};
  transition: background 0.15s ease;
  background: ${({ $current }) => $current ? 'rgba(0, 138, 255, 0.06)' : 'transparent'};

  &:hover {
    background: ${({ $current }) => $current ? 'rgba(0, 138, 255, 0.1)' : '#F4F5F9'};
  }

  &:active {
    background: #ECEDF2;
  }
`;

export const DropdownDivider = styled.div`
  height: 1px;
  background: #E4E7EF;
  margin: 4px 0;
`;

export default Dropdown;
